import { useState, useEffect } from "react";
import { ethers } from "@web3-onboard/common/node_modules/ethers";
import { SMART_CHAIN_RPC_URL } from "../components/Connect/config"; 

export const useExternalProvider = () => {
  const [externalProvider, setExternalProvider] = useState(null);

  const handleSetProvider = () =>{
    const speedyNodeProvider = new ethers.providers.JsonRpcProvider(SMART_CHAIN_RPC_URL);
    setExternalProvider(speedyNodeProvider);
  }

  useEffect(() => {
    if(externalProvider === null) handleSetProvider();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [externalProvider]);

  return { externalProvider };
}